﻿/**
 * debug-gateway.js
 * Wraps the ambient Debug panel module so consumers can depend on an adapter.
 */
export class DebugGateway {
  constructor({ debug = null } = {}) {
    this.debug = debug ?? (typeof window !== 'undefined' ? window.Debug || null : null);
  }

  get() {
    return this.debug || null;
  }

  update(method, ...args) {
    const target = this.get();
    if (!target) {
      return;
    }
    const fn = target?.[method];
    if (typeof fn === 'function') {
      try {
        fn.apply(target, args);
      } catch (error) {
        // ignore Debug gateway update errors
      }
    }
  }

  get instance() {
    return this.get();
  }

  setInstance(next) {
    this.debug = next;
  }
}

if (typeof window !== 'undefined') {
  window.AgileProGateways = window.AgileProGateways || {};
  window.AgileProGateways.DebugGateway = DebugGateway;
}
